



































































































































































































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import {
  resumeListReq,
  tabList,
  multipleSelectionReq,
  interviewReq,
} from "@/common/class/auditionList/index";
import {
  getResumeList,
  getTabList,
  getTabList23,
  sendInterviewNotice,
  getInterviewerList,
  evaluateDelivers,
  sendResults,
  getPosition,
  getDelState,
  getNoticeStateList,
} from "@/api/auditionList/index";
import myLoading from "@/components/global/my-loading/index.vue";
import filters from "@/common/filter/config/filter";

interface nameTest {
  majorDescribe: string;
}
@Component({
  components: {
    myLoading,
  },
})
export default class empowermentQueryComponent extends Vue {
  isRequest = false;
  req = new resumeListReq();
  tableloading = false;
  tableData = new DataParse();
  Height = 250;
  tabList1: Array<tabList> = [];
  tabList2: Array<tabList> = [];
  tabList3: Array<tabList> = [];
  clickNo = 0;
  clickValue = "";
  selectedId = "";
  multipleSelection: Array<multipleSelectionReq> = [];
  interviewDialogVisible = false;
  activeName = "first";
  interviewDialogloading = false;
  interviewForm = new interviewReq();
  interviewerList: Array<any> = [];
  checkAll = false;
  evaluationDialog = false;
  selectedList: any = [];
  noticeStateList: any = [];
  checkedInterviewer: Array<any> = [];
  isIndeterminate = true;
  chosePersonList: any = [];
  jobList: any = [];
  resultList: any = [];
  created() {
    this.init("");
    this.getInterviewer();
    this.getJobList();
    this.getResultList();
    this.getNoticeList();
  }
  async init(value: any) {
    await this.getTab1();
    await this.getTab23();
    this.originSHow(value);
  }
  //更换tab是列表默认展示第一个tab的数据
  originSHow(value: any) {
    //默认列表展示第一个
    if (this.tabList1.length > 0) {
      if (!value) {
        this.getList(this.tabList1[0].value);
      } else {
        this.getList(value);
      }
    }
    if (this.tabList2.length > 0 && this.activeName == "second") {
      if (!value) {
        this.getList(this.tabList2[0].value);
      } else {
        this.getList(value);
      }
    }
    if (this.tabList3.length > 0 && this.activeName == "third") {
      if (!value) {
        this.getList(this.tabList3[0].value);
      } else {
        this.getList(value);
      }
    }
  }
  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight, false);
  }
  getHeight() {
    //获取浏览器高度并计算得到表格所用高度。
    this.$nextTick(() => {
      //样式中没有写height的元素,dom.offsetHeight无法获取元素高度,加一个定时器即可
      setTimeout(() => {
        let dom = this.$refs.topDiv as HTMLFormElement;
        const height = dom.offsetHeight;
        this.Height = document.documentElement.clientHeight - height - 375;
      }, 80);
    });
  }
  // 获取岗位列表
  getJobList() {
    getPosition({ pageSize: 10000, pageNo: 1 })
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.jobList = data;
        }
      })
      .finally(() => {});
  }
  // 通知状态集合
  getNoticeList() {
    getNoticeStateList({})
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.noticeStateList = data;
        }
      })
      .finally(() => {});
  }
  getResultList() {
    getDelState({})
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.resultList = data;
        }
      })
      .finally(() => {});
  }
  // 预览文件
  fileView(val: any) {
    let url = val.attachmentAddress;
    window.open(
      `${process.env.VUE_APP_FILE_ONLINE_ADDRESS}?url=${url}`,
      "_blank"
    );
    // window.open(``, "_blank");
  }
  //  表格选择
  handleSelectionChange(data: any) {
    let ids: any = [];
    let arr: any = [];
    this.selectedList = [];
    data.forEach((item: any) => {
      ids.push(item.id);
      arr.push({
        id: item.id,
        name: item.name,
        phone: item.phone,
        jobName: item.jobName,
        state: item.state,
        evaluate: item.evaluate,
        attachmentName: item.attachmentName,
        attachmentAddress: item.attachmentAddress,
        offerJobId: item.offerJobId,
        offerJobName: item.offerJobName,
      });
    });
    this.selectedId = ids.join(",");
    this.selectedList = arr;
    this.multipleSelection = data;
    for (let k = 0; k < this.tableData.listItem.length; k++) {
      this.tableData.listItem[k].sort = "";
    }
    for (let i = 0; i < this.multipleSelection.length; i++) {
      for (let j = 0; j < this.tableData.listItem.length; j++) {
        if (this.multipleSelection[i].id == this.tableData.listItem[j].id) {
          this.tableData.listItem[j].sort = i + 1;
        }
      }
    }
  }
  // 全选
  selectAll(data: any) {
    let ids: any = [];
    let arr: any = [];
    this.selectedList = [];
    data.forEach((item: any) => {
      ids.push(item.id);
      arr.push({
        id: item.id,
        name: item.name,
        phone: item.phone,
        jobName: item.jobName,
        state: item.state,
        evaluate: item.evaluate,
        attachmentName: item.attachmentName,
        attachmentAddress: item.attachmentAddress,
        offerJobId: item.offerJobId,
        offerJobName: item.offerJobName,
      });
    });
    this.selectedId = ids.join(",");
    this.selectedList = arr;
  }
  interviewEvaluation() {
    if (this.selectedId) {
      this.evaluationDialog = true;
      this.chosePersonList = JSON.parse(JSON.stringify(this.selectedList));
    } else {
      this.$message({
        type: "warning",
        message: "请至少选择一条数据！",
      });
    }
  }
  // 获取列表
  getList(value: any) {
    this.tableloading = true;
    if (this.activeName == "second" || this.activeName == "third") {
      this.req.state = "";
    } else {
      this.req.state = value;
    }
    getResumeList(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.tableloading = false;
      });
  }
  //获取tab数据
  getTab1() {
    return getTabList({})
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tabList1 = data;
        }
      })
      .finally(() => {});
  }
  //获取tab数据
  getTab23() {
    return getTabList23({})
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tabList2 = data.running;
          this.tabList3 = data.over;
        }
      })
      .finally(() => {});
  }
  tabDetail(index: any, item: any, tab: any) {
    this.clickNo = index;
    this.clickValue = item.value;
    this.req.state = item.value;
    if (tab == "second" || tab == "third") {
      this.req.recUniversity = item.value;
      this.req.executeState = item.state;
      this.req.state = "";
    }
    this.getList(this.clickValue);
  }
  // 发送面试结果
  sendResult() {
    if (this.multipleSelection.length > 0) {
      let arr: any = [];
      this.selectedList.forEach((item: any) => {
        for (let value of this.jobList) {
          if ((value.id = item.offerJobId)) {
            item.offerJobName = value.jobName;
          }
        }
        arr.push({
          id: item.id,
          phone: item.phone,
          state: item.state,
          offerJobId: item.offerJobId,
          offerJobName: item.offerJobName,
        });
      });
      // param.results = JSON.stringify(param.results);
      sendResults(arr)
        .then((res) => {
          const { data, message, success } = res;
          if (success) {
            this.$message({
              type: "success",
              message: "发送成功！",
            });
          }
          this.multipleSelection = [];
        })
        .finally(() => {});
    } else {
      this.$message({
        type: "warning",
        message: "请至少选择一条数据",
      });
    }
  }
  goInterview() {
    if (this.multipleSelection.length > 0) {
      this.interviewDialogVisible = true;
      this.interviewForm = new interviewReq();
    } else {
      this.$message({
        type: "warning",
        message: "请至少选择一条数据",
      });
    }
  }
  getInterviewer() {
    getInterviewerList({ departmentCodes: "9999" })
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          if (data.length > 0) {
            this.interviewerList = [];
            for (let item of data) {
              let obj = { value: item.id, label: item.userName };
              this.interviewerList.push(obj);
            }
          }
        }
      })
      .finally(() => {});
  }
  interviewFinish(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.interviewForm.interviewer =
          this.interviewForm.interviewer.join(",");
        this.interviewDialogloading = true;
        this.interviewForm.interviewTime = filters.dateFormat(
          this.interviewForm.interviewTime
        );
        let param = [];
        let idString = "";
        let phoneString = "";
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (i != this.multipleSelection.length - 1) {
            idString += this.multipleSelection[i].id + ",";
            phoneString += this.multipleSelection[i].phone + ",";
          } else {
            idString += this.multipleSelection[i].id;
            phoneString += this.multipleSelection[i].phone;
          }
        }
        this.interviewForm.id = idString;
        this.interviewForm.phone = phoneString;
        sendInterviewNotice(this.interviewForm)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.$message({
                type: "success",
                message: "发送成功!",
              });
              this.interviewDialogVisible = false;
              this.interviewForm = new interviewReq();
              this.init(this.clickValue);
            } else {
              this.$message({
                type: "error",
                message: "发送失败!",
              });
            }
          })
          .finally(() => {
            this.interviewDialogloading = false;
          });
      }
    });
  }
  //正整数正则表达式
  validateZS = (rule: any, value: any, callback: any) => {
    let CEN = new RegExp(/^[1-9]\d*$/);
    if (!CEN.test(value)) {
      return callback(new Error("由正整数组成"));
    } else {
      callback();
    }
  };
  rules = {
    interviewTime: [{ required: true, message: "必填", trigger: "blur" }],
    interval: [
      {
        required: true,
        validator: this.validateZS,
        trigger: "blur",
      },
    ],
    interviewer: [{ required: true, message: "必填", trigger: "change" }],
    content: [{ required: true, message: "必填", trigger: "blur" }],
  };
  // 评价提交
  submit() {
    let arr: any = [];
    this.chosePersonList.forEach((item: any) => {
      arr.push({
        id: item.id,
        state: item.state,
        evaluate: item.evaluate,
        offerJobId: item.offerJobId,
        offerJobName: item.offerJobName,
      });
    });
    // param.delivers = JSON.stringify(param.delivers);
    evaluateDelivers(arr)
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.$message({
            type: "success",
            message: "评价成功！",
          });
          this.init(this.clickValue);
          this.multipleSelection = [];
          this.chosePersonList = [];
        } else {
          this.$message({
            type: "error",
            message: "评价失败！",
          });
        }
      })
      .finally(() => {
        this.evaluationDialog = false;
      });
  }
  handleClick(tab: any, event: any) {
    this.tableData.listItem = [];
    this.clickNo = 0;
    this.clickValue = "";
    if (this.activeName == "second") {
      this.req.recUniversity = this.tabList2[0].value;
      this.req.executeState = this.tabList2[0].state;
      this.req.state = "";
    }
    if (this.activeName == "third") {
      this.req.recUniversity = this.tabList3[0].value;
      this.req.executeState = this.tabList3[0].state;
      this.req.state = "";
    }
    if (this.activeName == "first") {
      this.req.recUniversity = "";
      this.req.executeState = "";
    }
    this.originSHow("");
  }
  // 取消评价框
  cancel() {
    this.evaluationDialog = false;
    this.chosePersonList = [];
  }
  changePage(index: number) {
    this.req.pageNo = index;
    this.getList("");
  }
}
